import { render, staticRenderFns } from "./ProhibitDialog.vue?vue&type=template&id=6110125e&"
import script from "./ProhibitDialog.vue?vue&type=script&lang=js&"
export * from "./ProhibitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports